var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 399 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2916_1503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.617 167.338C198.461 167.338 203.199 161.412 203.199 154.102C203.199 146.791 198.461 140.865 192.617 140.865C186.772 140.865 182.035 146.791 182.035 154.102C182.035 161.412 186.772 167.338 192.617 167.338Z",
    stroke: "#28293E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.457 243.216C226.775 242.249 226.934 241.224 226.934 240.143C226.934 234.849 222.815 230.551 217.718 230.551C212.62 230.551 208.501 234.849 208.501 240.143C208.501 241.281 208.683 242.363 209.025 243.359",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.431 120.199H135.702V143.624H154.431V120.199Z",
    stroke: "#28293E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.091 182.535H135.042L145.055 160.334L155.091 182.535Z",
    stroke: "#28293E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.822 134.262C427.058 147.81 423.463 167.877 410.309 173.256C402.413 176.472 386.551 174.793 386.87 160.704C387.052 152.393 394.084 150.828 398.794 154.983C406.008 161.359 406.987 175.761 403.846 185.097C387.985 232.259 329.272 217.316 324.607 168.304C322.945 150.771 329.181 135.088 338.58 122.621C343.245 116.445 348.524 111.037 354.009 106.028C359.243 101.218 365.433 97.7164 369.847 91.5971C373.557 86.4452 374.171 76.1986 369.256 70.876C364.454 65.6964 356.853 68.5425 354.441 75.8856C353.576 78.5327 353.486 81.3789 353.372 84.1967C353.303 85.7335 353.69 87.8686 353.03 89.263C351.847 91.7111 348.411 91.4831 346.499 91.5114C344.246 91.5404 341.72 91.8251 341.06 88.3239C338.693 75.7433 342.721 66.4648 347.318 55.8196C350.095 49.3586 351.824 40.0228 348.092 33.2203C343.45 24.7669 334.006 23.9699 326.792 23.9699C311.363 23.9414 291.314 20.6967 279.412 34.7573C271.811 43.7514 270.832 54.1403 271.515 66.4074C272.061 76.341 273.199 92.4795 263.641 96.2647",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.15 93.3315C315.664 93.1041 325.927 93.7585 327.519 105.4C327.633 106.197 327.155 106.909 326.496 106.909H309.155",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.754 63.6747C317.325 56.2175 325.767 56.0467 327.224 63.6747",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.138 71.6424C248.076 75.798 252.468 76.3957 257.11 75.485C262.503 74.4319 270.354 67.6865 271.379 59.7168",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.146 234.478C199.853 232.458 202.357 229.782 204.928 227.476C207.568 225.114 210.117 222.581 212.688 220.104C214.805 218.056 216.83 215.75 219.629 215.949C224.181 216.291 227.594 220.417 230.848 223.805C234.148 227.22 243.182 235.902 237.106 241.822C235.195 243.672 230.985 243.188 227.913 243.188C225.182 243.188 222.907 243.415 220.63 243.359H195.917H178.28H170.543H121.434C117.587 243.359 114.47 239.459 114.47 234.649C114.47 229.839 117.587 225.94 121.434 225.94H148.446C151.109 225.94 153.521 223.975 154.59 220.93L160.188 205.048C161.076 202.543 159.619 199.754 157.435 199.754H124.073C121.775 199.754 119.909 197.42 119.909 194.545V106.937C119.909 104.063 121.775 101.729 124.073 101.729H214.509C216.807 101.729 218.674 104.063 218.674 106.937V194.517C218.674 197.391 216.807 199.725 214.509 199.725H179.008C176.892 199.725 175.436 202.401 176.186 204.877L182.991 226.822C183.924 229.839 182.149 233.084 179.577 233.084H128.898L122.799 233.169C112.558 233.624 97.971 235.247 91.9177 222.04C89.5736 216.917 87.503 208.577 89.8012 202.942C93.1696 194.659 100.861 199.242 101.202 206.983C101.771 220.361 92.4409 231.575 82.1778 233.026C78.4001 233.567 74.5085 232.771 71.118 230.636C64.4045 226.367 60.65 217.144 60.081 208.008C59.7395 202.686 61.2643 193.094 66.9989 193.549C71.8689 193.919 73.5986 201.632 73.6666 206.614C73.7804 214.326 70.7081 220.902 66.0885 225.74C61.0594 230.978 54.5055 234.279 47.997 232.4C41.9437 230.664 36.4137 225.171 33.7967 218.112C32.1582 213.7 30.9749 208.207 31.5893 203.34C32.1582 198.9 35.0256 193.293 39.1673 194.745C45.7213 197.05 44.8793 209.175 43.3774 215.722C40.3507 228.985 28.3351 234.678 18.231 232.913C9.151 231.319 3.02943 224.801 0.503418 214.042",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.573 96.2917C271.401 97.3447 271.834 108.701 271.424 116.414C270.946 125.551 269.353 137.135 277.227 142.714C284.509 147.866 296.866 143.169 304.08 147.98C313.547 154.298 308.518 167.362 304.763 176.271C299.847 187.97 289.015 199.668 286.284 212.419C281.733 233.623 292.315 243.13 308.131 243.414C322.763 243.671 337.396 243.642 352.029 243.642C366.798 243.642 383.98 246.574 394.425 234.506C401.366 226.479 397.451 213.273 392.559 204.648C386.528 194.032 378.085 187.229 374.217 175.019C369.37 159.763 374.24 142.97 377.858 128.169C381.135 114.82 384.321 101.415 387.552 88.0372C392.058 69.3089 394.675 48.8442 387.006 30.7989C378.973 11.8143 362.474 -0.0261385 345.634 0.656961C330.023 1.28314 309.747 13.0667 307.676 35.1252C306.788 44.4609 309.86 53.7682 308.154 63.0472C306.675 71.0453 301.327 77.307 297.389 83.5687C295.136 87.1549 295.341 91.7658 299.188 92.8472C301.918 93.6155 303.875 92.8472 306.583 93.6155C308.904 94.2706 309.36 96.6047 309.268 99.3935C308.927 108.729 309.155 117.666 308.768 127.373C308.518 133.321 308.131 142.6 312.432 146.955C316.96 151.566 324.083 149.374 329.431 149.431C330.342 149.431 331.275 149.46 332.185 149.63C348.888 152.875 329.067 188.567 325.289 197.049C317.484 214.639 307.972 234.563 290.813 238.547C276.954 241.764 263.846 229.155 263.596 211.252C263.322 192.068 280.481 183.672 291.018 174.564C300.507 166.338 310.111 154.326 301.395 140.01C295.728 130.703 285.806 121.082 286.102 108.189C286.17 105.656 286.557 103.179 287.126 100.789C290.494 86.4148 301.258 70.7606 290.016 57.4968C280.618 46.3964 265.029 46.1687 254.584 55.0775C238.472 68.8252 240.338 95.3803 241.499 116.557C241.886 123.729 242.591 131.756 237.971 137.335C234.035 142.088 226.206 148.691 230.735 156.262C232.965 159.99 239.792 157.942 244.093 158.624C251.717 159.877 250.67 175.816 250.806 183.672L250.761 194.061C250.601 201.574 250.488 207.267 250.397 214.554C250.283 222.267 250.989 232.997 246.073 239.345C238.563 249.022 228.687 237.865 223.111 230.891C221.495 228.87 219.106 226.138 216.671 227.732C214.646 229.07 212.848 230.976 210.959 232.542C209.275 233.936 207.546 235.274 205.748 236.469C204.087 237.58 202.22 238.889 200.309 238.547C198.966 238.292 196.986 236.669 197.054 234.734",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.318 225.286C206.407 225.343 205.497 225.457 204.587 225.571C201.788 225.912 197.714 226.738 195.439 224.29C194.301 223.066 192.936 219.109 195.826 219.081C199.148 219.053 202.493 218.768 205.816 218.284C209.366 217.772 215.078 216.576 218.605 215.979",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.48 193.008H128.943C127.123 193.008 125.644 191.158 125.644 188.882V113.655C125.644 111.378 127.123 109.527 128.943 109.527H209.48C211.301 109.527 212.78 111.378 212.78 113.655V188.853C212.78 191.158 211.301 193.008 209.48 193.008Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.348 129.963C251.918 129.963 254.811 125.032 254.811 118.949C254.811 112.865 251.918 107.934 248.348 107.934C244.779 107.934 241.885 112.865 241.885 118.949C241.885 125.032 244.779 129.963 248.348 129.963Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.18 111.122C240.452 109.728 239.542 108.902 238.563 108.902C236.196 108.902 234.262 113.656 234.262 119.548C234.262 125.411 236.196 130.192 238.563 130.192C239.769 130.192 240.884 128.94 241.658 126.947",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.603 175.788C258.635 175.788 266.895 175.845 271.606 168.16",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.082 120.458C274.427 121.767 279.889 121.112 283.075 116.074",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.086 114.567C310.952 115.506 316.414 115.079 318.553 112.176C318.507 112.204 318.462 112.261 318.417 112.289",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.452 81.0068C276.727 74.7735 283.485 74.6028 284.669 81.0068",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.246 120.656H312.068C312.773 120.656 313.319 121.368 313.319 122.222V126.378C313.319 127.26 312.75 127.943 312.068 127.943H308.927",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.857 118.635H260.091",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.916 121.822H198.898",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.916 127.26H198.898",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.916 132.695H172.682",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.188 159.252H172.955",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.188 164.689H172.955",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.188 170.125H172.955",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2916_1503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 245,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomIllustration);
export default __webpack_public_path__ + "static/media/Bottom_Illustration.a02c95ca2a44f8845f54fb01041fd476.svg";
export { ForwardRef as ReactComponent };